// Available icons and colors for categories

export const CATEGORY_ICONS = [
  { emoji: '🎲', label: 'Dice' },
  { emoji: '♠️', label: 'Spade' },
  { emoji: '🧍', label: 'Board Game' },
  { emoji: '🎯', label: 'Indoor' },
  { emoji: '🪵', label: 'Outdoor' },
  { emoji: '⚽', label: 'Sports' },
  { emoji: '🎮', label: 'Gaming' },
  { emoji: '🏆', label: 'Trophy' },
  { emoji: '⭐', label: 'Star' },
  { emoji: '🎪', label: 'Activities' },
];

export const CATEGORY_COLORS = [
  { value: '#EF4444', label: 'Red', bg: 'bg-red-500', text: 'text-red-500', light: 'bg-red-100' },
  { value: '#F97316', label: 'Orange', bg: 'bg-orange-500', text: 'text-orange-500', light: 'bg-orange-100' },
  { value: '#EAB308', label: 'Yellow', bg: 'bg-yellow-500', text: 'text-yellow-500', light: 'bg-yellow-100' },
  { value: '#10B981', label: 'Green', bg: 'bg-green-500', text: 'text-green-500', light: 'bg-green-100' },
  { value: '#3B82F6', label: 'Blue', bg: 'bg-blue-500', text: 'text-blue-500', light: 'bg-blue-100' },
  { value: '#8B5CF6', label: 'Purple', bg: 'bg-purple-500', text: 'text-purple-500', light: 'bg-purple-100' },
  { value: '#EC4899', label: 'Pink', bg: 'bg-pink-500', text: 'text-pink-500', light: 'bg-pink-100' },
  { value: '#6B7280', label: 'Gray', bg: 'bg-gray-500', text: 'text-gray-500', light: 'bg-gray-100' },
];

export const getColorClasses = (colorValue) => {
  const color = CATEGORY_COLORS.find(c => c.value === colorValue);
  return color || CATEGORY_COLORS[0];
};
